import { STAGE_EXTRAJUDICIAL_COMMUNICATION_SENT } from "../../Stages/StagesCase";
import { previewFeedbackMessageButton } from "./litigationCaseDetailsSpecialActions";
import { EmploymentContract } from "../../../types/Products/EmploymentLaw/EmploymentContract";

export const employmentContractDetailsSpecialActions = (product: EmploymentContract) => {
  let specialActions = [];

  if (product.stage === STAGE_EXTRAJUDICIAL_COMMUNICATION_SENT) {
    specialActions.push(previewFeedbackMessageButton(product));
  }

  if (specialActions.length === 0) {
    return null;
  }

  return specialActions;
};
